import React, { Suspense } from 'react'
import Media from 'react-media'
import { Loader } from 'src/components/shared/Loader'
import { SIZES } from 'src/styles/theme'
import MobileAuditorium from 'src/mobileOnlyPages/MobileAuditorium'
import AuditoriumPage from 'src/webOnlyPages/AuditoriumPage'
import PlenaryLeaveGuard from 'src/components/PlenaryLeaveGuard'

// Tracking does NOT live here. App.tsx routes the auditorium twice — once in
// each branch of its <Media> split — so this container remounts every time the
// viewport crosses 819px (a phone rotating into video fullscreen does exactly
// that). The hooks live in src/containers/AuditoriumTracker.tsx, mounted above
// that split, so one visit produces one tracked session.
export default function AuditoriumContainer({ currentUser }) {
  return (
    <Loader>
      {/* Attendance reminder on every way out of the hall. */}
      <PlenaryLeaveGuard />
      <Suspense fallback={<div>Loading...</div>}>
        <Media query={`(max-width: ${SIZES.mobileBreakpoint})`}>
          {(matches) =>
            matches ? 
              <MobileAuditorium currentUser={currentUser}/> 
              : 
              <AuditoriumPage currentUser={currentUser} />
          }
        </Media>
      </Suspense>
    </Loader>
  )
}
